module.exports = __webpack_public_path__ + "img/infrastructure-14.2d781388.png";